import { APIClient } from '@frontend/api-utils';

export class WizardJsonClient extends APIClient {
    public static readonly endpoint = '/wizard-api/json/v1';

    public static async fetchWizardJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/wizards`);
        return await this.handleBlobResponse(response);
    }

    public static async fetchSingleWizardJson(accountId: string, wizardId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}`);
        return await this.handleBlobResponse(response);
    }

    public static async postWizardJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/wizards`, formData);
        return await this.handleBlobResponse(response);
    }
}
